<template>
  <div class="item">
    <router-link :to="$store.getters['main/getSingleUrl'](item)">
      <p class="ttl font-21 f-roman underline">
        {{ _.get(item, "grantee_oganization") }}
      </p>
    </router-link>
    <p class="desc font-16 f-medium">
      <span class="font-16 f-medium">{{ $fn.tr("Projects") }}: </span
      >{{ _.get(item, "title") }}
    </p>
    <div class="data-cont">
      <div class="inner-item">
        <p class="budget font-16 f-roman">
          {{ $fn.tr("Budget") }}:
          <span class="font-16 f-bold" style="white-space: nowrap;"
            >{{ getBudget }} ₾</span
          >
        </p>
        <p class="status font-16 f-roman">
          {{ $fn.tr("Status") }}:
          <span
            class="font-16 f-bold"
            :class="{
              active:
                _.get(item, 'status') === 'Active' ||
                _.get(item, 'status') === 'აქტიური'
            }"
            >{{ $fn.tr(_.get(item, "status")) }}</span
          >
        </p>
      </div>
      <p
        class="duration font-16 f-roman"
        v-if="_.get(item, 'project_duration')"
      >
        {{ $fn.tr("Project Duration") }}:
        <span class="font-16 f-medium">{{ getDuration }}</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {
    getBudget() {
      var data = _.get(this.item, "budget");
      data = parseFloat(data);
      var res = new Intl.NumberFormat().format(data);
      return res;
    },
    getDuration() {
      var data = [
        _.get(this.item, "project_duration"),
        _.get(this.item, "project_duration_to")
      ];
      if (data !== undefined) {
        for (var i = 0; i < data.length; i++) {
          if (data[i] !== undefined) {
            data[i] = data[i].replace("-", "/");
            data[i] = data[i].replace("-", "/");
          }
        }
        data = data.join(" - ");
        return data;
      }
    }
  }
};
</script>
